// extracted by mini-css-extract-plugin
export default {"container":"Tab_container__dH9UH","image":"Tab_image__PBVcj","paragraph":"Tab_paragraph__8PKna","title":"Tab_title__0M56R","video":"Tab_video__AfN+D","button":"Tab_button__GadGo"};